import "./Portfolio.scss"
import AnimateDiv from "../AnimateDiv/AnimateDiv";

function Portfolio() {
    return (
        <div id="work" className="portfolio">
            <AnimateDiv>
                <div className="d-flex flex-column">
                    <div className="mb-5 w-50 w-md-100">
                        <h4 className="hero__title">PORTFOLIO.</h4>
                        <div className="hero__subtitle">
                            Showcasing my apps. <strong>Click</strong> the boxes for more details
                        </div>
                    </div>

                    <div className="portfolio__wrapper pt-4">
                        <div className="portfolio__row">
                            <div className="portfolio__item maserati" data-cmp="trigger-hover" data-trigger="hover-3">
                                <div className="hover" data-hover-cmp="true" data-cmp="hover-3">
                                    <img className="portfolio__phone-image" src="/images/maserati/maserati_resized.webp"
                                         alt="maserati-site"/>
                                </div>
                            </div>

                            <div className="portfolio__details">
                                <div className="portfolio__details-wrapper">
                                    <div className="portfolio__details-front">
                                        <div className="portfolio__title">Maserati</div>

                                        <div className="portfolio__text">
                                            Dev contribution on the new redesigned website of <a
                                            target="_blank"
                                            href="https://www.maserati.com/global/en">Maserati</a>.
                                            Mostly on the Front-End,worked on complex animations, unique components
                                            that incorporated cut of the edge trends.
                                        </div>

                                        <div className="portfolio__subtitle">-WEB APP</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="portfolio__row">
                            <div className="portfolio__item illy" data-cmp="trigger-hover"
                                 data-trigger="hover-illy">
                                <div className="hover" data-hover-cmp="true" data-cmp="hover-illy">
                                    <img className="portfolio__phone-image" src="/images/illy.png" alt="illy" />
                                </div>
                            </div>

                            <div className="portfolio__details">
                                <div className="portfolio__details-wrapper">
                                    <div className="portfolio__details-front">
                                        <div className="portfolio__title">Illy Cafe</div>

                                        <div className="portfolio__text">
                                            Dev contribution on the website of <a target="_blank" href="https://www.illy.com/it-it">Illy
                                            Cafe</a>. Maintaining and implementing new features for the registration and
                                            subscriptions.
                                        </div>

                                        <div className="portfolio__subtitle">-WEB APP</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="portfolio__row">
                            <div className="portfolio__item firenze" data-cmp="trigger-hover"
                                 data-trigger="hover-firenze">
                                <div className="hover" data-hover-cmp="true" data-cmp="hover-firenze">
                                    <img className="portfolio__phone-image" src="/images/firenze.png" alt="firenze" />
                                </div>
                            </div>

                            <div className="portfolio__details">
                                <div className="portfolio__details-wrapper">
                                    <div className="portfolio__details-front">
                                        <div className="portfolio__title">Unicoop Firenze</div>

                                        <div className="portfolio__text">
                                            Dev contribution on the website of <a target="_blank" href="https://www.coopfirenze.it/">Unicoop Firenze</a>.
                                            Maintaining and implementing new features.
                                        </div>

                                        <div className="portfolio__subtitle">-WEB APP</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="portfolio__row">
                            <div className="portfolio__item etruria" data-cmp="trigger-hover"
                                 data-trigger="hover-etruria">
                                <div className="hover" data-hover-cmp="true" data-cmp="hover-etruria">
                                    <img className="portfolio__phone-image" src="/images/etruria.png" alt="etruria" />
                                </div>
                            </div>

                            <div className="portfolio__details">
                                <div className="portfolio__details-wrapper">
                                    <div className="portfolio__details-front">
                                        <div className="portfolio__title">Unicoop Etruria</div>

                                        <div className="portfolio__text">
                                            Lead developer on the website of <a target="_blank" href="https://coopetruria.coop.it">Unicoop Etruria</a>.
                                            Maintaining and implementing new features.
                                            Worked on Back-end, service integrations,
                                            created automated asset delivery service
                                            and Full-Stack for the Private Area that handles most user's interactions.
                                        </div>

                                        <div className="portfolio__subtitle">-WEB APP</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="portfolio__row">
                            <div className="portfolio__item worldcup" data-cmp="trigger-hover"
                                 data-trigger="hover-worldcup">
                                <div className="hover" data-hover-cmp="true" data-cmp="hover-worldcup">
                                    <img className="portfolio__phone-image" src="/images/worldcup.png" alt="worldcup" />
                                </div>
                            </div>

                            <div className="portfolio__details">
                                <div className="portfolio__details-wrapper">
                                    <div className="portfolio__details-front">
                                        <div className="portfolio__title">World Cup 2026 3D</div>

                                        <div className="portfolio__text">
                                            Developed from scratch a 3D Web App for the <a target="_blank" href="https://worldcup2026-cfb0f.web.app">World Cup 2026 Brackets</a> in a circular format.
                                            Users can interact and see real-time data of the tournament.
                                            Created with React.js and Three.js.
                                        </div>

                                        <div className="portfolio__subtitle">-WEB APP</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="portfolio__row">
                            <div className="portfolio__item edupal" data-cmp="trigger-hover"
                                 data-trigger="hover-edupal">
                                <div className="hover" data-hover-cmp="true" data-cmp="hover-edupal">
                                    <img className="portfolio__phone-image" src="/images/edupal.png" alt="edupal" />
                                </div>
                            </div>

                            <div className="portfolio__details">
                                <div className="portfolio__details-wrapper">
                                    <div className="portfolio__details-front">
                                        <div className="portfolio__title">Edupal</div>

                                        <div className="portfolio__text">
                                            Lead developer in the educational platform of <a target="_blank" href="https://edupal.gr">edupal.gr</a>.
                                            It provides a fully equipped toolset for managing, examining and deliver content to students in the private sector.
                                        </div>

                                        <div className="portfolio__subtitle">-WEB APP</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="portfolio__row">
                            <div className="portfolio__item vocalchess" data-cmp="trigger-hover"
                                 data-trigger="hover-vocalchess">
                                <div className="hover" data-hover-cmp="true" data-cmp="hover-vocalchess">
                                    <img className="portfolio__phone-image" src="/images/vocalchess.png" alt="vocal-chess" />
                                </div>
                            </div>

                            <div className="portfolio__details">
                                <div className="portfolio__details-wrapper">
                                    <div className="portfolio__details-front">
                                        <div className="portfolio__title">Vocal Chess</div>

                                        <div className="portfolio__text">
                                            <a target="_blank" href="https://chromewebstore.google.com/detail/vocalchess-voice-control/dmekkklalbdkpiadofffjfheglhegihl?authuser=0&hl=en">Vocal Chess</a> is a
                                            chrome extension designed to control chess pieces in the chess.com platform.
                                            It also provides features such as Text-To-Speech, auto-confirm
                                            and automatically go to next puzzle.
                                        </div>

                                        <div className="portfolio__subtitle">-CHROME EXTENSION</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="portfolio__row" data-hover="row">
                            <div className="portfolio__item wallet" data-cmp="trigger-hover" data-trigger="hover-1">
                                <div className="hover" data-hover-cmp="true" data-cmp="hover-1">
                                    <img className="portfolio__phone-image" src="/images/wallet/wallet-1.webp"
                                         alt="wallet analyzer img 1"/>
                                    <img className="portfolio__phone-image" src="/images/wallet/wallet-3.webp"
                                         alt="wallet analyzer img 2"/>
                                    <img className="portfolio__phone-image" src="/images/wallet/wallet-2.webp"
                                         alt="wallet analyzer img 3"/>
                                </div>
                            </div>

                            <div className="portfolio__details">
                                <div className="portfolio__details-wrapper">
                                    <div className="portfolio__details-front">
                                        <div className="portfolio__title">Wallet Analyzer</div>

                                        <div className="portfolio__text">
                                            Android Application I developed for my thesis in Technological Educational
                                            Institute of Central Macedonia.
                                            Users can manage their expenses, scan receipts, see analytical reports with a nice UI and graphs.
                                            <a href="https://github.com/druit/Wallet-Analyzer" target="_blank">
                                            Github Repo
                                        </a>
                                        </div>

                                        <div className="portfolio__subtitle">-ANDROID APP</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="portfolio__row">
                            <div className="portfolio__item map-keeper" data-cmp="trigger-hover" data-trigger="hover-2">
                                <div className="hover" data-hover-cmp="true" data-cmp="hover-2">
                                    <img className="portfolio__phone-image" src="/images/map-keeper/Screenshot 2026-07-03 170047.png"
                                         alt="map-keeper-1"/>
                                    {/*    <img className"portfolio__phone-image" src="images/wallet/wallet-3.png" alt=""/>*/}
                                    {/*<img className"portfolio__phone-image" src="images/wallet/wallet-2.png" alt=""/> */}
                                </div>
                            </div>

                            <div className="portfolio__details">
                                <div className="portfolio__details-wrapper">
                                    <div className="portfolio__details-front">
                                        <div className="portfolio__title">Map Keeper</div>

                                        <div className="portfolio__text">A <a href="https://dm-map-keeper.web.app/" target="_blank">
                                            Web App</a> I've created for
                                            Dungeons & Dragons tool to help organize maps, players, notes and campaigns.
                                        </div>

                                        <div className="portfolio__subtitle">-WEB APP</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </AnimateDiv>
        </div>
    );
}

export default Portfolio;
